import { ISiteSettingsForServerAdmin } from '../../settings/interfaces/ISite';
import { L10n } from '../L10n/L10n';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { Sites } from '../resources/Sites';
import { AbstractContentAction } from './AbstractContentAction';
import { ConfirmActionDialog, IConfirmActionDialogOptions } from './ConfirmActionDialog';
import { ContentActionNotification, INotificationTranslationIds } from './ContentActionNotification';

export interface IChangeSiteAvailabilityScope extends ng.IScope {
  dialog: {
    siteName: string;
  };
}

export class ActivateSitesAction extends AbstractContentAction<ISiteSettingsForServerAdmin> {

  public static $inject = ['ConfirmActionDialog', 'ContentActionNotification', '$translate',  'Sites'];

  constructor(
    ConfirmActionDialog: ConfirmActionDialog,
    ContentActionNotification: ContentActionNotification,
    private $translate: ng.translate.ITranslateService,
    private Sites: Sites) {
    super(ConfirmActionDialog, ContentActionNotification);
  }

  configureDialog(dialogConfig: IConfirmActionDialogOptions, sites: Set<ISiteSettingsForServerAdmin>) {
    const scope = <IChangeSiteAvailabilityScope> dialogConfig.scope;

    scope.dialog = {
      siteName: sites.first().settings.name
    };

    dialogConfig.bodyText = this.$translate.instant('confirmActivateSites', {
      SITE_NAME: L10n.elideIfLong(scope.dialog.siteName),
      ITEM_COUNT: sites.size()
    }, L10n.Interpolations.Count);
    dialogConfig.title = this.$translate.instant('activateSites');
    dialogConfig.actionName = this.$translate.instant('activateButtonConfirm', {
      ITEM_COUNT: sites.size()
    }, L10n.Interpolations.Count);
    dialogConfig.action = () => this.Sites.activate(sites.keys());
  }

  notificationTranslationIds(): INotificationTranslationIds {
    return {
      successId: 'sitesActivateSuccess',
      errorId: 'sitesActivateFailed'
    };
  }

  notificationTranslationValues(scope: ng.IScope): Object {
    return {
      SITE_NAME: L10n.elideIfLong((<IChangeSiteAvailabilityScope>scope).dialog.siteName)
    };
  }

}

Module.instance().service('ActivateSitesAction', ActivateSitesAction);
